import { useFormikContext } from "formik";
import { get } from "lodash";
import { useEffect, useMemo } from "react";
import usePrevious from "../../utils/usePrevious";

function HandleFieldChange<FormValues>({
  name,
  onChange
}: {
  name: string;
  onChange: (value: any) => void;
}) {
  const { values } = useFormikContext<FormValues>();

  const value = useMemo(() => get(values, name), [name, values]);

  const prevValue = usePrevious(value);
  useEffect(() => {
    if (value !== prevValue) {
      onChange(value);
    }
  }, [onChange, prevValue, value]);

  return null;
}

export default HandleFieldChange;
